import React, { useContext } from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import { DataContext as EmployeeTableContext } from '../../../stores/emp-table-store';

import { DataContext } from '../../../stores/officehours-table-store';

import ClickableTableCell from '../shared/ClickableTableCell';

const OfficeHoursTableCell = ({ row, column }) => {
    const { dispatch } = useContext(EmployeeTableContext);
    const { store } = useContext(DataContext);
    const { FTECheckboxVal, FTEValList } = store;

    const columnName = column.name;

    if (columnName === 'name') {
        return (
            <ClickableTableCell
                href={`/employees`}
                showText={row[columnName]}
                onClick={() => {
                    dispatch({ type: 'NAVIGATION_FROM_INTERNALHOURS', rowName: row.name });
                }}
            />
        );
    }

    const hours = row[columnName] ?? '0';
    let classes = 'text-right';

    if (FTECheckboxVal) {
        var valPerFTE = 0.0;

        const idString = row.id + columnName;
        if (FTEValList[idString]) {
            valPerFTE = FTEValList[idString].FTEVal;
        }

        row[columnName] = valPerFTE;

        if (valPerFTE === 0.0) {
            valPerFTE = '0.0';
        }

        return (
            <Table.Cell className={classes}>
                <div className='d-flex align-items-center h-100 justify-content-end'>{valPerFTE}</div>
            </Table.Cell>
        );
    }

    const idString = row.id + columnName;
    var origVal = 0.0;

    if (FTEValList[idString]) {
        origVal = FTEValList[idString].OrigVal;
    }

    row[columnName] = origVal;

    const hasDecimals = (hours || 0) % 1 !== 0;

    if (hasDecimals) {
        classes += ' padding-right-none';
    }

    if (origVal === 0.0) {
        origVal = '0.0';
    }

    return (
        <Table.Cell className={classes}>
            <div className='d-flex align-items-center h-100 justify-content-end'>{origVal}</div>
        </Table.Cell>
    );
};

export default OfficeHoursTableCell;
